
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxMontpellier = () => {
  return (
    <CityMetauxPage
      cityName="Montpellier"
      departmentName="Hérault"
      departmentCode="34"
      region="Occitanie"
      description="Métropole méditerranéenne et technopôle majeur, Montpellier bénéficie de notre expertise dans le rachat de métaux issus des secteurs high-tech, médical et de la recherche universitaire."
      specialities={[
        "Métaux high-tech et électroniques",
        "Équipements médicaux et de recherche",
        "Métaux de construction moderne",
        "Ferraille urbaine métropolitaine"
      ]}
      nearbyAreas={[
        "Lattes", "Pérols", "Castelnau-le-Lez", "Grabels", "Juvignac", "Saint-Jean-de-Védas"
      ]}
      heroImage="https://images.unsplash.com/photo-1493397212122-2b85dda8106b?w=1280&q=80"
    />
  );
};

export default AchatMetauxMontpellier;
